// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/illustration-template/src/index.tsx

import baseIllustration from '@bubble-ui/temp-illustration-base';
var IllustrationReduceAdminPath = 'M82 19.2V30h1.5C89.299 30 94 34.701 94 40.5V68h-7.898A50.099 50.099 0 0093.4 91l-5.8 4a57.3 57.3 0 01-8.512-27h-6.037A135.8 135.8 0 0076.9 96.6l-6.8 1.8A150.4 150.4 0 0166.064 68h-6.046c.151 15.138 1.229 27.721 1.444 30.242.025.283.038.44.038.458l-7 .6-.02-.235c-.165-1.903-1.31-15.082-1.463-31.065h-6.034c-.153 15.983-1.298 29.162-1.463 31.065l-.02.235-6.9-.6c0-.019.012-.175.035-.458.202-2.52 1.207-15.104 1.349-30.242h-6.048A150.4 150.4 0 0129.9 98.4l-6.8-1.8A135.8 135.8 0 0026.95 68h-6.038A57.298 57.298 0 0112.4 95l-5.8-4a50.099 50.099 0 007.298-23H6V40.5C6 34.701 10.701 30 16.5 30H18V0h44.8C73.404 0 82 8.596 82 19.2zM75 30H25V7h35v15.5h15V30zm-.575-14.5A12.199 12.199 0 0067 7.746V15.5h7.425zM75 54a5 5 0 100-10 5 5 0 000 10zm12 7H13V40.5a3.5 3.5 0 013.5-3.5h67a3.5 3.5 0 013.5 3.5V61z';
var IllustrationReduceAdmin = baseIllustration('IllustrationReduceAdmin', {
  getPath: () => IllustrationReduceAdminPath
});

/**
 * @deprecated this component is outdated and will be removed with v6.0.0
 */
export default IllustrationReduceAdmin;
//# sourceMappingURL=index.js.map